import React, { useState, useEffect } from 'react';
import GridAdd from '../../../../components/GridAdd/GridAdd';
import { Color } from '../../../../const/Const';
import { API } from '../../../../API/API';
import NewLang from './New/NewLang';
import { hideLoadScreen, showLoadScreen } from '../../../../components/LoadScreen/LoadScreen';
import { useParams } from 'react-router-dom';

const Language = (props) => {

    const params = useParams();
    const [empid, setEmpId] = useState(-1);
    const [onOpenLang, setOnOpenLang] = useState(false);
    const [dataLang, setDataLang] = useState([]);
    const [entryidLang, setEntryIdLang] = useState();

    useEffect(() => {
        let tEmpId = -1;
        if (params.empid) {
            tEmpId = params.empid;
        }
        setEmpId(tEmpId);
    }, [params]);

    const getExistsData = async () => {

        let tDataLang = [];
        if (empid > 0) {
            showLoadScreen();
            await API.get('/api/humanresource/employee/get_empforlanguage_list?empid=' + empid).then(response => {
                if (response.status == 200 && response.data?.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tDataLang = response.data.retdata;
                    }
                }
            });
            hideLoadScreen();
        }

        setEntryIdLang();
        setDataLang(tDataLang);
    }

    useEffect(() => {
        getExistsData();
    }, [empid]);

    const onDismissLang = () => {
        setEntryIdLang(-1);
        setOnOpenLang(false);
    }

    const onEditLang = (p_entryid) => {
        setEntryIdLang(p_entryid);
        setOnOpenLang(true);
    }

    const afterSaveLang = async (p_close) => {
        if (p_close) {
            setOnOpenLang(false);
        }
        getExistsData();
    }

    return (
        <div style={{ padding: 8 }}>
            <div>
                <GridAdd
                    title={`Хэлний мэдлэг ${dataLang.length > 4 ? `(${dataLang.length})` : ""}`}
                    description=""
                    onNew={() => { setOnOpenLang(true); }}
                    data={dataLang}
                    columns={[{
                        name: 'Гадаад хэл',
                        fieldName: 'forlanguagename',
                        maxWidth: 300,
                        minWidth: 120,
                        onRender: (item) => {
                            return (
                                <div
                                    onClick={() => onEditLang(item.entryid)}
                                    style={{ color: Color.blue, cursor: 'pointer' }}
                                >
                                    {item.forlanguagename}
                                </div>
                            );
                        }
                    }, {
                        name: 'Уншиж ойлгох',
                        fieldName: 'readinglevelname',
                        maxWidth: 250,
                        minWidth: 120,
                    }, {
                        name: 'Бичиж орчуулах',
                        fieldName: 'writinglevelname',
                        maxWidth: 250,
                        minWidth: 120,
                    }, {
                        name: 'Ярьсныг ойлгох',
                        fieldName: 'listeninglevelname',
                        maxWidth: 250,
                        minWidth: 120,
                    }, {
                        name: 'Өөрөө ярих',
                        fieldName: 'speakinglevelname',
                        maxWidth: 250,
                        minWidth: 120,
                    }, {
                        name: 'Үзсэн хугацаа /сараар/',
                        fieldName: 'studytime'
                    }, {
                        name: 'Ielts оноо',
                        fieldName: 'ieltsscore'
                    }, {
                        name: 'Toefl оноо',
                        fieldName: 'toeflscore'
                    }]}
                />
                <NewLang
                    entryid={entryidLang}
                    empid={empid}
                    onOpen={onOpenLang}
                    onDismiss={onDismissLang}
                    afterSave={afterSaveLang} />
            </div>
        </div>
    );
}

export default Language;